import React from 'react';

function Orders() {

  return (
    <React.Fragment>
      <h1>Orders</h1>
    </React.Fragment>
  );
}

export default Orders;
